import { render, staticRenderFns } from "./fitting-slot.vue?vue&type=template&id=250533fb&scoped=true&"
import script from "./fitting-slot.vue?vue&type=script&lang=js&"
export * from "./fitting-slot.vue?vue&type=script&lang=js&"
import style0 from "./fitting-slot.vue?vue&type=style&index=0&id=250533fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250533fb",
  null
  
)

export default component.exports